module.exports = __webpack_public_path__ + "static/media/partners-profile.dc15b1d1.png";